import { z } from 'zod';

const zodIsoDatetimeWithOptionalTimezoneSchema = z.union([
  z.iso.datetime({ local: true }),
  z.iso.datetime({ offset: true }),
]);

const zodSupplierSuggestionItemSchema = z.object({
  address: z.string().nullish(),
  companyId: z.uuid().nullish(),
  deliveryCount: z.number().int(),
  lastUsedAt: zodIsoDatetimeWithOptionalTimezoneSchema,
  name: z.string().nullish(),
});

export const zodSupplierSuggestionsResponseSchema = z.object({
  data: z.array(zodSupplierSuggestionItemSchema),
});
